import React from 'react'
import styled from 'styled-components'

import { SourceIcon as Icon } from 'components'
import { TooltipIconButton } from 'components/TooltipIconButton'
import { Source } from 'features/products/types'
import mixpanel from 'trackers/mixpanel'

type Props = {
  source: Source
}

const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1)

export const SourceIcon: React.FC<Props> = ({ source }) => {
  if (!source.source_url) {
    return null
  }

  const sourceKey = source.syndicated_source ? 'syndicated' : source.source_type
  const sourceName = source.syndicated_source
    ? capitalize(source.syndicated_source)
    : source.source_type

  const handleClick = (): void => {
    mixpanel.track('product data', {
      action: 'source card',
      value: source.source_url,
    })
    window.open(source.source_url, '_blank', 'noopener,noreferrer')
  }

  return (
    <TooltipIconButton
      tooltipTitle={
        <TooltipBody>
          <TooltipName>{sourceName}</TooltipName>
          <TooltipUrl>{source.source_url}</TooltipUrl>
        </TooltipBody>
      }
      tooltipSide="top"
      icon={<StyledIcon source={sourceKey} />}
      onClick={handleClick}
      height={55}
      width={55}
    />
  )
}

const StyledIcon = styled(Icon)`
  width: 60%;
  height: 60%;
`

const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const TooltipName = styled.span`
  font-weight: 600;
`

const TooltipUrl = styled.span`
  font-size: 11px;
  opacity: 0.8;
  word-break: break-all;
`
